import { DisplayPlayerManager } from '@signage-player/player';
import { LoggerInterface } from '@signage-player/contracts';
import { WebPlayerManagerFactory } from './WebPlayerManagerFactory';

/**
 * Browser flavor of the display player manager. Single display per tab —
 * inherits the base class behavior entirely. The base class accepts a
 * factory and calls `factory.createForDisplay(displayId)` to materialize a
 * PlayerManager when initializeForDisplay/getOrInitializeForDisplay are called.
 */
export class WebDisplayPlayerManager extends DisplayPlayerManager {
  constructor(logger: LoggerInterface, factory: WebPlayerManagerFactory) {
    super(logger, factory);
  }
}

export default WebDisplayPlayerManager;
